import BannerComp from "../components/BannerComp";
import Faqs from "../components/Faqs";
import Seo from "../components/Seo";
import { faqpage } from "../data/faqpage";
import { createBreadcrumbSchema, createWebPageSchema } from "../lib/seo";

const seo = {
  title: "Frequently Asked Questions | MIT4Doctors",
  description:
    "Answers to the questions we hear most often from patients and healthcare providers.",
  schema: [
    createWebPageSchema({
      path: "/frequently-asked-questions",
      title: "Frequently Asked Questions",
      description:
        "Answers to the questions we hear most often from patients and healthcare providers.",
    }),
    createBreadcrumbSchema(
      "/frequently-asked-questions",
      "Frequently Asked Questions",
    ),
  ],
};

export default function FrequentlyAsked() {
  return (
    <>
      <Seo
        title={seo.title}
        metaTitle={seo.title}
        description={seo.description}
        canonicalPath="/frequently-asked-questions"
        schema={seo.schema}
      />
      <BannerComp
        heading="Frequently Asked Questions"
        paragraph="Answers to the questions we hear most often from patients and healthcare providers."
        centered
        BannerBgImg="/img/banners/about_hero.webp"
      />

      <Faqs title={"MITSI Services"} faqs={faqpage} />
    </>
  );
}
